import React from 'react';
import QrReader from 'react-qr-reader';
import { supportsWebcam } from '../../utils/supportsWebcam';
import { SvgBackground } from './tapScreen';
import { PenIcon } from './penIcon';
import { renderToStaticMarkup } from 'react-dom/server';
import Input from './InputScanner';
import { COLOR } from '../../const/color';
import './QrCameraScanner.scss';
import { arrayOfWarehouseLocations } from '../../const/HubConfig';

export interface QrShelfScannerState {
  scannerIsOpen: boolean;
  flash: boolean;
  scanDelay: number;
  deviceNotFound: boolean;
  scanResultOrderId: string;
  editResultOrderId: string;
  displayOrderId: string;
}

export interface QrShelfScannerProps {
  handleClickButton?: (data: string, data2: boolean) => void;
  handleWarehouseScan?: (
    orderIdForShelfId: string,
    parcelId: string,
    shelfId: string
  ) => void;
  disabledButton?: boolean;
  titleButton?: string;
  orderIdForShelId?: number;
  orderIdForShelfId?: string;
  parcelId?: string;
  setShelfId?: boolean;

  shelfId?: string;

  scannerIsOpen: boolean;

  isScanWarehouse?: boolean;
}
export class QrShelfScanner extends React.Component<
  QrShelfScannerProps,
  QrShelfScannerState
> {
  constructor(props) {
    super(props);

    this.state = {
      scanDelay: 300,
      scannerIsOpen: this.props.scannerIsOpen,
      flash: false,
      deviceNotFound: false,
      scanResultOrderId: '',
      editResultOrderId: '',
      displayOrderId: '',
    };
  }

  static defaultProps = {
    disabledButton: false,
    titleButton: 'BEKREFT',
  };

  public svgString = encodeURIComponent(
    renderToStaticMarkup(<SvgBackground />)
  );
  public dataUri = `url("data:image/svg+xml,${this.svgString}")`;

  public svgStringPenIcon = (colorIcon = 'white') => {
    return encodeURIComponent(renderToStaticMarkup(PenIcon(colorIcon)));
  };

  public dataUriPenIcon = colorIcon => {
    return `url("data:image/svg+xml,${this.svgStringPenIcon(colorIcon)}")`;
  };

  public openScanner = () => {
    this.setState({ scannerIsOpen: true });
  };
  public closeScanner = () => {
    this.setState({
      scannerIsOpen: false,
      scanResultOrderId: '',
    });
  };

  public parseJsonData(data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return undefined;
    }
  }

  public parseShelfId(data) {
    if (data) {
      if (data.startsWith('{') && data.endsWith('}')) {
        return this.parseJsonData(data);
      }
      return { shelfId: data };
    }
    return { shelfId: '' };
  }

  public onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const orderId = e.target.value;
    const orderIdWithoutSpace = orderId.replace(/\s/g, '');

    if (this.state.editResultOrderId !== orderIdWithoutSpace) {
      this.setState({
        editResultOrderId: orderIdWithoutSpace,
        displayOrderId: orderIdWithoutSpace,
      });
    }
  };

  public editInputField = (isDisabled = false) => {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: '4px',
            border: `1px solid ${
              this.state.scannerIsOpen ? COLOR.LIGHTER_GRAY : COLOR.GREEN
            }`,
            borderColor: this.state.scannerIsOpen
              ? COLOR.LIGHTER_GRAY
              : COLOR.GREEN,
          }}
        >
          <Input
            type={'text'}
            onChange={this.onInputChange}
            value={this.state.displayOrderId}
            style={{
              width: '250px',
              fontSize: '3rem',
              textAlign: 'center',
              border: 'none',
            }}
            disabled={isDisabled}
          />
          <button
            className="qr-penIcon-button"
            style={{
              background: `${this.dataUriPenIcon(
                this.state.scannerIsOpen ? COLOR.LIGHTER_GRAY : COLOR.PRIMARY
              )}  no-repeat`,
              height: 25,
              width: 25,
              paddingLeft: 50,
            }}
            disabled={!this.state.scannerIsOpen}
            onClick={this.state.scannerIsOpen ? this.closeScanner : null}
          />
        </div>
        <div style={{ height: '5px' }} />
      </div>
    );
  };

  public handleScan = data => {
    if (data) {
      const orderData = this.parseShelfId(data);
      if (
        this.state.scanResultOrderId !== orderData.shelfId &&
        orderData.shelfId !== ''
      ) {
        this.setState({
          scanResultOrderId: String(orderData.shelfId),
          displayOrderId: String(orderData.shelfId),
          flash: true,
          scannerIsOpen: true,
        });
        setTimeout(() => {
          this.setState({
            flash: false,
            scannerIsOpen: true,
          });
        }, 1000);
      }
    }
  };

  public handleScanError = data => {
    console.table(data);
    this.setState({
      displayOrderId: '',
      scannerIsOpen: false,
    });
  };

  public handleClickButton = () => {
    if (
      arrayOfWarehouseLocations().includes(
        this.state.scanResultOrderId.toLowerCase()
      )
    ) {
      this.props.handleWarehouseScan(
        this.props.orderIdForShelfId,
        this.props.parcelId,
        this.state.scanResultOrderId.toLowerCase()
      );
    } else if (this.props.handleClickButton) {
      this.props.handleClickButton(
        this.state.displayOrderId,
        this.state.scannerIsOpen
      );
    }
    this.makeReadyForNewScan();
  };

  public makeReadyForNewScan = () => {
    this.setState({
      displayOrderId: '',
    });
    setTimeout(() => {
      this.setState({
        editResultOrderId: '',
        scanResultOrderId: '',
      });
    }, 2500);
  };

  public bekreftKnapp = () => {
    return (
      <div className="qr-shelf-scanner__confrimButtonPosition">
        <button
          className={'confirmButton'}
          onClick={this.handleClickButton}
          title={this.props.titleButton}
          disabled={
            this.props.isScanWarehouse
              ? this.props.disabledButton ||
                !arrayOfWarehouseLocations().includes(
                  this.state.scanResultOrderId.toLowerCase()
                )
              : this.props.disabledButton
          }
        >
          {this.props.titleButton}
        </button>
      </div>
    );
  };

  public render() {
    if (!supportsWebcam || this.state.deviceNotFound) {
      return (
        <div className="qr-shelf-scanner">
          <div className="qr-shelf-scanner__scanner u-pam">
            Din nettleser støtter ikke QR-scanneren, prøv Safari på iOS eller
            Chrome på Android
          </div>
          {this.editInputField()}
          {this.bekreftKnapp()}
        </div>
      );
    }
    if (this.state.scannerIsOpen) {
      return (
        <div className={this.state.flash ? ' scan is-flashing' : 'scan'}>
          <div className="qr-shelf-scanner">
            <QrReader
              delay={this.state.scanDelay}
              onError={this.handleScanError}
              onScan={this.handleScan}
              className="qr-shelf-scanner__scanner"
            />
          </div>
          {this.editInputField(true)}
          {this.bekreftKnapp()}
        </div>
      );
    } else {
      return (
        <div className="qr-shelf-scanner">
          <button
            className="qr-shelf-scanner__startbutton"
            style={{ background: this.dataUri }}
            onClick={this.openScanner}
          >
            SCAN SHELF
          </button>
          {this.editInputField(false)}
          {this.bekreftKnapp()}
        </div>
      );
    }
  }
}
